export const TmpMainPage = () => (
    <div className="w-full text-center">
        <h1 className="text-3xl font-bold">Page in development</h1>
        <p>We apologize for the temporary inconvenience</p>
    </div>
);
